// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/group_class/v1/group_class.proto (package fingertip.creator.group_class.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3, Timestamp } from "@bufbuild/protobuf";
import { GroupClass } from "../../../common/type/v1/group_class_pb.js";
import { GroupClassAttendance } from "../../../common/type/v1/group_class_attendance_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { StorePayment } from "../../../common/type/v1/store_payment_pb.js";
import { StoreInvoice } from "../../../common/type/v1/store_invoice_pb.js";
import { EventType } from "../../../common/type/v1/event_type_pb.js";
import { UserProfile } from "../../../common/type/v1/user_profile_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";
import { Page } from "../../../common/type/v1/page_pb.js";
import { StoreConfig } from "../../../common/type/v1/store_config_pb.js";

/**
 * @generated from message fingertip.creator.group_class.v1.CreateGroupClassesRequest
 */
export const CreateGroupClassesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CreateGroupClassesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "booking_policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "times", kind: "message", T: CreateGroupClassesTime, repeated: true },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "waitlist_enabled", kind: "message", T: BoolValue },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CreateGroupClassesTime
 */
export const CreateGroupClassesTime = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CreateGroupClassesTime",
  () => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CreateGroupClassesResponse
 */
export const CreateGroupClassesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CreateGroupClassesResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.UpdateGroupClassRequest
 */
export const UpdateGroupClassRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.UpdateGroupClassRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_time", kind: "message", T: Timestamp },
    { no: 4, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "max_attendees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "booking_policy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "waitlist_enabled", kind: "message", T: BoolValue },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.UpdateGroupClassResponse
 */
export const UpdateGroupClassResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.UpdateGroupClassResponse",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassRequest
 */
export const GetGroupClassRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GroupClassAttendee
 */
export const GroupClassAttendee = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GroupClassAttendee",
  () => [
    { no: 1, name: "attendance", kind: "message", T: GroupClassAttendance },
    { no: 2, name: "contact", kind: "message", T: SiteContact },
    { no: 3, name: "payments", kind: "message", T: StorePayment, repeated: true },
    { no: 4, name: "invoice", kind: "message", T: StoreInvoice },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassResponse
 */
export const GetGroupClassResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassResponse",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "attendees", kind: "message", T: GroupClassAttendee, repeated: true },
    { no: 3, name: "event_type", kind: "message", T: EventType },
    { no: 4, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.DeleteGroupClassRequest
 */
export const DeleteGroupClassRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.DeleteGroupClassRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.DeleteGroupClassResponse
 */
export const DeleteGroupClassResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.DeleteGroupClassResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesRequest
 */
export const GetGroupClassesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesResponse
 */
export const GetGroupClassesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesResponse",
  () => [
    { no: 1, name: "group_classes", kind: "message", T: GroupClass, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesInRangeRequest
 */
export const GetGroupClassesInRangeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesInRangeRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start", kind: "message", T: Timestamp },
    { no: 3, name: "end", kind: "message", T: Timestamp },
    { no: 4, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GroupClassRecord
 */
export const GroupClassRecord = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GroupClassRecord",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "user", kind: "message", T: UserProfile },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesInRangeResponse
 */
export const GetGroupClassesInRangeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesInRangeResponse",
  () => [
    { no: 2, name: "items", kind: "message", T: GroupClassRecord, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CancelGroupClassRequest
 */
export const CancelGroupClassRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CancelGroupClassRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cancellation_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "charge_cancellation_fee", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CancelGroupClassResponse
 */
export const CancelGroupClassResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CancelGroupClassResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CompleteGroupClassRequest
 */
export const CompleteGroupClassRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CompleteGroupClassRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "no_show", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "charge_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.CompleteGroupClassResponse
 */
export const CompleteGroupClassResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.CompleteGroupClassResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesPublicRequest
 */
export const GetGroupClassesPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "include_unavailable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start", kind: "message", T: Timestamp },
    { no: 6, name: "end", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetGroupClassesPublicResponse
 */
export const GetGroupClassesPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetGroupClassesPublicResponse",
  () => [
    { no: 1, name: "group_classes", kind: "message", T: GroupClass, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.BookGroupClassPublicRequest
 */
export const BookGroupClassPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.BookGroupClassPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "group_class_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "target_attendance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.BookGroupClassPublicResponse
 */
export const BookGroupClassPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.BookGroupClassPublicResponse",
  () => [
    { no: 1, name: "attendance", kind: "message", T: GroupClassAttendance },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetCustomerGroupClassItem
 */
export const GetCustomerGroupClassItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetCustomerGroupClassItem",
  () => [
    { no: 1, name: "group_class", kind: "message", T: GroupClass },
    { no: 2, name: "event_type", kind: "message", T: EventType },
    { no: 3, name: "site", kind: "message", T: Site },
    { no: 4, name: "page", kind: "message", T: Page },
    { no: 5, name: "attendee", kind: "message", T: GroupClassAttendance },
    { no: 6, name: "config", kind: "message", T: StoreConfig },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetCustomerGroupClassesRequest
 */
export const GetCustomerGroupClassesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetCustomerGroupClassesRequest",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "start", kind: "message", T: Timestamp },
    { no: 5, name: "end", kind: "message", T: Timestamp },
    { no: 6, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "event_status_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.group_class.v1.GetCustomerGroupClassesResponse
 */
export const GetCustomerGroupClassesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.group_class.v1.GetCustomerGroupClassesResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetCustomerGroupClassItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

